import { api } from "@/client/api"

export default {

    changeCreditLimit(providerKey, request) {
        console.log("POST", providerKey, request)
        return api.post(`/providers/${encodeURIComponent(providerKey)}/account/change-credit-limit`, request)
    }
}
